import type { ReceivableCurrency } from "./receivable.types";

export enum ReceivableTaxType {
  IOF = "IOF",
  DAS = "DAS",
  ICMS = "ICMS",
  OTHER = "OTHER",
}

export const RECEIVABLE_TAX_TYPE_LABELS: Record<ReceivableTaxType, string> = {
  [ReceivableTaxType.IOF]: "IOF",
  [ReceivableTaxType.DAS]: "DAS",
  [ReceivableTaxType.ICMS]: "ICMS",
  [ReceivableTaxType.OTHER]: "Outro",
};

export enum ReceivableTaxDocumentType {
  RECEIPT = "RECEIPT",
  CALCULATION = "CALCULATION",
  DECLARATION = "DECLARATION",
}

export const RECEIVABLE_TAX_DOCUMENT_TYPE_LABELS: Record<ReceivableTaxDocumentType, string> = {
  [ReceivableTaxDocumentType.RECEIPT]: "Comprovante",
  [ReceivableTaxDocumentType.CALCULATION]: "Cálculo",
  [ReceivableTaxDocumentType.DECLARATION]: "Declaração",
};

export interface ReceivableTax {
  id: string;
  receivableId: string;
  currency: ReceivableCurrency;
  type: ReceivableTaxType;
  description?: string | null;
  document?: string | null;
  value: number;
  createdBy?: string | null;
  createdAt: string;
  updatedBy?: string | null;
  updatedAt?: string;
  documents?: ReceivableTaxDocument[];
}

export interface ReceivableTaxDocument {
  id: string;
  receivableTaxId: string;
  documentUrl: string;
  documentType: ReceivableTaxDocumentType;
  description?: string | null;
  createdBy?: string | null;
  createdAt: string;
  file?: File;
}

export interface PendingReceivableTax {
  id: string;
  currency: ReceivableCurrency;
  type: ReceivableTaxType;
  description?: string;
  document?: string;
  value: number;
  createdAt: string;
  updatedAt?: string;
  documents?: PendingReceivableTaxDocument[];
}

export interface PendingReceivableTaxDocument {
  id: string;
  documentUrl?: string;
  documentType: ReceivableTaxDocumentType;
  description?: string;
  file?: File;
  createdAt: string;
}

export interface CreateReceivableTaxPayload {
  receivableId: string;
  currency: ReceivableCurrency;
  type: ReceivableTaxType;
  description?: string;
  document?: string;
  value: number;
}

export interface UpdateReceivableTaxPayload {
  id: string;
  receivableId?: string;
  currency?: ReceivableCurrency;
  type?: ReceivableTaxType;
  description?: string;
  document?: string;
  value?: number;
}

export interface CreateReceivableTaxDocumentPayload {
  receivableTaxId: string;
  documentType: ReceivableTaxDocumentType;
  description?: string;
  documentUrl?: string;
  file?: File;
}

export interface UpdateReceivableTaxDocumentPayload {
  id: string;
  receivableTaxId?: string;
  documentType?: ReceivableTaxDocumentType;
  description?: string;
  documentUrl?: string;
  file?: File;
}

export type PaginatedReceivableTaxesResponse = import("@/features/profiles/services/profiles/types").PaginatedResponse<ReceivableTax>;

